import React, { useEffect, useState, useContext } from "react";
import { useFirestore } from "../../firebase/FirestoreContext";
import { getDoc, doc, updateDoc, setDoc } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EnvContext } from "../../../context/EnvContext";
import config from "../../../config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const LegalPrivacy = () => {
  const environment = useContext(EnvContext);
  const db = useFirestore();

  // Choose the correct collection path based on the environment
  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  // We use a single field: legalContent
  const [legalContent, setLegalContent] = useState("");

  // On mount, load the existing legal content from a hardcoded document (id: "legal")
  useEffect(() => {
    const fetchLegalContent = async () => {
      try {
        const docRef = doc(db, `${collectionPath}Help/Legal/Legal`, "LegalPrivacy");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setLegalContent(docSnap.data().legalContent || "");
        }
      } catch (error) {
        console.error("Error fetching legal content:", error);
      }
    };
    fetchLegalContent();
  }, [db, collectionPath]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, `${collectionPath}Help/Legal/Legal`, "LegalPrivacy");
      await setDoc(docRef, { legalContent }, { merge: true });
      toast.success("Legal content updated successfully!");
    } catch (error) {
      toast.error("Error updating legal content!");
      console.error("Error updating legal content:", error);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar />
      <h2>Legal Content Editor</h2>
      <form onSubmit={handleSubmit}>
        <ReactQuill value={legalContent} onChange={setLegalContent} style={{ height: "300px", marginBottom: "50px" }} />
        <button type="submit" style={styles.button}>
          Save
        </button>
      </form>
    </div>
  );
};

const styles = {
  button: {
    backgroundColor: "#478169",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default LegalPrivacy;
